export default __webpack_public_path__ + "static/media/error_icon.77742298.svg";